(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name webAgro1App.Dashboard
   * @description
   * # Dashboard
   * Service in the webAgro1App.
   */
  angular
    .module('webAgro1App')
    .factory('Dashboard', DashboardService);

  /**
   * DashboardService dependencies
   */
  DashboardService.$inject = [
    '$http'
  ];

  /**
   * DashboardService declaration
   */
  function DashboardService($http) {
    //////////////////////////////////////////
    // Service data

    //////////////////////////////////////////
    // Service object declaration
    var service = {
      glebasVisitadas: GlebasVisitadas,
      pragasVsAplicacoes: PragasVsAplicacoes,
      dadosMeteorologicos: DadosMeteorologicos,
      cronograma: Cronograma,
      calcChartWidth: CalcChartWidth
    };
    return service;

    //////////////////////////////////////////
    // Function declarations

    function GlebasVisitadas(propriedade) {
      return $http.get(SERVER + 'v1/dashboard/glebas_visitadas', {
        params: {
          propriedade: propriedade
        }
      });
    }

    function PragasVsAplicacoes(filter) {
      return $http.get(SERVER + 'v1/dashboard/populacao_pragas', {
        params: filter
      });
    }

    function DadosMeteorologicos(filter) {
      return $http.get(SERVER + 'v2/dados_meteorologicos', {
        params: filter
      });
    }

    function Cronograma(filter) {
      return $http.get(SERVER + 'v1/dashboard/schedule', {
        params: filter
      });
    }
  }

  function CalcChartWidth(width) {
    // Calculation explained @ controllers/widgetestacaometeorologica.js
    var parentWidth = Number(width.slice(0, -1)) / 100 * window.innerWidth - 40;
    return parentWidth;
  }

}());
